// Após a migration 000800, contacts.category é TEXT livre (slug da categoria)
export type ContactCategory = string;
export type ContactGender = 'M' | 'F' | 'outro' | 'prefiro_nao_informar';

export interface Contact {
  id: string;
  tenant_id: string;
  full_name: string;
  birth_date: string | null;
  gender: ContactGender | null;
  cpf: string | null;
  phone: string | null;
  phone_whatsapp: boolean;
  email: string | null;
  zip_code: string | null;
  street: string | null;
  street_number: string | null;
  complement: string | null;
  neighborhood: string | null;
  city: string | null;
  state_code: string | null;
  voter_registration: string | null;
  electoral_zone: string | null;
  electoral_section: string | null;
  category: string;        // slug da categoria (ex: 'eleitor', 'vereador', ...)
  tags: string[];          // slugs das tags do tenant
  leader_id: string | null;
  notes: string | null;
  engagement_score: number;
  latitude: number | null;
  longitude: number | null;
  active: boolean;
  created_by: string | null;
  created_at: string;
  updated_at: string;
  // join
  leader?: Pick<Contact, 'id' | 'full_name'> | null;
}

export interface ContactInsert {
  full_name: string;
  category: string;
  phone?: string | null;
  phone_whatsapp?: boolean;
  email?: string | null;
  birth_date?: string | null;
  gender?: ContactGender | null;
  cpf?: string | null;
  zip_code?: string | null;
  street?: string | null;
  street_number?: string | null;
  complement?: string | null;
  neighborhood?: string | null;
  city?: string | null;
  state_code?: string | null;
  voter_registration?: string | null;
  electoral_zone?: string | null;
  electoral_section?: string | null;
  leader_id?: string | null;
  tags?: string[];
  notes?: string | null;
  engagement_score?: number;
  latitude?: number | null;
  longitude?: number | null;
}

export interface ContactUpdate extends Partial<ContactInsert> {
  active?: boolean;
}

export interface ContactFilters {
  search: string;
  category: string | 'all';
  neighborhood: string;
  activeOnly: boolean;
}

// ─── Categoria de contato (lookup table) ─────────────────────────────────────
export interface ContactCategoryRow {
  id: string;
  tenant_id: string | null; // null = padrão de plataforma
  label: string;
  color_class: string;
  slug: string;
  active: boolean;
  sort_order: number;
}

// ─── Tag de contato (lookup table) ───────────────────────────────────────────
export interface ContactTagRow {
  id: string;
  tenant_id: string | null; // null = sugestão de plataforma (somente leitura)
  label: string;
  color_class: string;
  slug: string;
  active: boolean;
  sort_order: number;
}

// ─── Paleta de cores para categorias/tags novas ───────────────────────────────
export const COLOR_PALETTE: string[] = [
  'bg-blue-500/15 text-blue-300 border-blue-500/25',
  'bg-emerald-500/15 text-emerald-300 border-emerald-500/25',
  'bg-amber-500/15 text-amber-300 border-amber-500/25',
  'bg-purple-500/15 text-purple-300 border-purple-500/25',
  'bg-rose-500/15 text-rose-300 border-rose-500/25',
  'bg-cyan-500/15 text-cyan-300 border-cyan-500/25',
  'bg-orange-500/15 text-orange-300 border-orange-500/25',
  'bg-teal-500/15 text-teal-300 border-teal-500/25',
  'bg-indigo-500/15 text-indigo-300 border-indigo-500/25',
  'bg-pink-500/15 text-pink-300 border-pink-500/25',
  'bg-lime-500/15 text-lime-300 border-lime-500/25',
  'bg-slate-500/15 text-slate-300 border-slate-500/25',
];

export const GENDER_LABELS: Record<ContactGender, string> = {
  M: 'Masculino',
  F: 'Feminino',
  outro: 'Outro',
  prefiro_nao_informar: 'Prefiro não informar',
};

export const STATE_CODES = [
  'AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS',
  'MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC',
  'SP','SE','TO',
];

// Fallback para quando as categorias do tenant ainda não foram carregadas
export const DEFAULT_CATEGORY_LABELS: Record<string, string> = {
  eleitor:      'Eleitor',
  lideranca:    'Liderança',
  voluntario:   'Voluntário',
  doador:       'Doador',
  simpatizante: 'Simpatizante',
};
